<template>
  <Fragment>
    <template v-if="$route.name !== 'synopsis'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <span>上传说明书</span>
            </div>
            <div class="text item">
              <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="文件:">
                  <el-upload
                    ref="upload"
                    :data="uploadData"
                    accept=".doc,.application/msword"
                    :action="fileUrl"
                    :limit="1"
                    :headers="getHeaders"
                    :on-error="handleError"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleSuccess"
                  >
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">
                      只能上传doc文件，且不超过30mb
                    </div>
                  </el-upload>
                </el-form-item>
              </el-form>
            </div>
          </el-card>
        </section>
      </div>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Breadcrumb from "@/components/Breadcrumb";
import Setting from "@/config/setting";
import VueCookie from "@/config/util.cookies";

export default {
  name: "synopsis",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      form: {},
      uploadData: {
        fileName: "海尔i-OID平台用户帮助文档1.doc"
      },
      fileUrl: Setting.fileUrl,
      getHeaders: {
        Authorization: "Bearer " + VueCookie.get("token")
      }
    };
  },
  methods: {
    handleError() {
      let _this = this;
      _this.$message({
        message: "文件上传失败!",
        type: "warning"
      });
    },
    handleSuccess(response, file, fileList) {
      let _this = this;
      if (response.status == 200) {
        _this.$message({
          message: "文件上传成功!",
          type: "success"
        });
      } else {
        _this.$message({
          message: "文件上传失败!",
          type: "warning"
        });
        fileList = [];
      }
    },
    handleBeforeUpload(file) {
      let _this = this;
      const typeFlag =
        file.type === ".doc" || file.type === "application/msword";
      const sizeFlag = file.size / 1024 / 1024 < 30;
      if (!typeFlag) {
        _this.$message.error("只允许上传doc类型文件!");
      }
      if (!sizeFlag) {
        _this.$message.error("上传文件大小不能超过 30MB!");
      }
      return typeFlag && sizeFlag;
    }
  },
  created() {
    let _this = this;
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
    .card-content
        display: flex
        align-items: center
        justify-content: space-between

        .box-card
            width: 50%
</style>
